export default function last(arr) {
   // eslint-disable-next-line no-magic-numbers
   return arr[arr.length - 1];
}
